import axios from "axios"
// import { toast } from "react-toastify"
// let logoutFn

// export const setLogoutHandler = fn => {
//     logoutFn = fn
// }

export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
})
axiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem("authUser")
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    error => {
        // console.error("Request error:", error)
        return Promise.reject(error)
    },
)

axiosInstance.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error.response) {
            // console.error("Response error:", error.response.data)

            if (error.response.status === 401) {
                // Handle unauthorized access (e.g., token expired)
                // logoutFn()
                // localStorage.removeItem("authUser")
                // toast.error("Session expired. Please log in again.")
                console.warn("Unauthorized. Redirecting to login...")
            }
        } else {
            // console.error("Network error:", error.message)
        }
        return Promise.reject(error)
    },
)